<template>
    <div class="progbar_wrap" :class="wrapClasses">
        <div class="progbar_section" :style="sectionStyles">
            <div class="percent">{{percent}}%</div>
        </div>
    </div>
</template>

<script>

    import {default as _} from "lodash";

    export default {

        mounted() {
        },

        data: () => ({
        }),

        methods: {
        },

        props: {
            row: {
                type: Object,
                required: true,
            },
            now: {
                type: Number
            },
        },

        computed: {
            secondsElapsed() {
                let seconds = 0;
                let now = this.now;
                let row = this.row;

                _.forEach(this.row.users, function(user) {
                    // for each user, add how many seconds are recorded as done
                    seconds += isNaN(user.seconds) ? 0 : user.seconds;

                    // no need to calc for non-running users
                    if (typeof user.running_since_unix === 'undefined' || user.running_since_unix === null)
                        return;

                    // item and process view rows that are not batched can simply add the real seconds
                    if (row.batch_hash === null) {
                        seconds += now - user.running_since_unix;
                        return;
                    }

                    // apportion the elapsed seconds between the batch's processes, according to their relative size
                    let elapsedSeconds = now - user.running_since_unix;
                    let workEstPercentOfBatch = (row.est_seconds / row.batch_est_seconds) * 100;
                    let relativeSeconds = Math.round((elapsedSeconds / 100) * workEstPercentOfBatch);

                    seconds += relativeSeconds;
                });

                return Math.round(seconds);
            },
            percent()
            {
                let seconds = this.secondsElapsed;
                let max = this.row.est_seconds;
                return max === 0 || seconds === 0 ? 0 : Math.round((seconds / max) * 100);
            },
            sectionStyles() {
                let seconds = this.secondsElapsed;
                let max = this.row.est_seconds;
                let width = seconds > max ? 100 : this.percent;

                return "width: "+width+"%;";
            },
            wrapClasses() {
                return {
                    'progbar-status-ok': this.percent <= 90,
                    'progbar-status-warning': this.percent > 90 && this.percent <= 110,
                    'progbar-status-danger': this.percent > 110,
                };
            },
        }

    }
</script>

<style>
    .progbar_wrap {
        width: 100%;
        border: 1px solid #666;
        border-radius: 7px;
        background-color: #eee;
        height: 30px;
        overflow: hidden;
        display: inline-block;
        opacity: 0.6;
    }
    .progbar_section {
        float: left;
        background-color: darkgray;
        height: 100%;
    }
    .percent {
        font-weight: bold;
        font-size: 14px;
        color: #fff;
        margin: 4px 8px 0 8px;
        background-color: #0000004a;
        position: absolute;
        padding: 0 5px 2px 5px;
        border-radius: 3px;
    }

    .progbar-status-ok .progbar_section {
        background-color: #187e18;
        border-right: 1px solid #20602a;
    }
    .progbar_wrap.progbar-status-ok {
        border-color: #20602a;
    }

    .progbar-status-warning .progbar_section {
        background-color: #f0be12;
        border-right: 1px solid #a28318;
    }
    .progbar_wrap.progbar-status-warning {
        border-color: #a28318;
    }
    .progbar-status-warning .percent {
        color: #000;
    }

    .progbar-status-danger .progbar_section {
        background-color: #b40000;
    }
    .progbar_wrap.progbar-status-danger {
        border-color: #350606;
    }
</style>